module.exports = __webpack_public_path__ + "static/media/33-10.e0308895.mp3";